import { render, staticRenderFns } from "./AppTexts.vue?vue&type=template&id=2bf3779a"
import script from "./AppTexts.vue?vue&type=script&lang=ts"
export * from "./AppTexts.vue?vue&type=script&lang=ts"
import style0 from "./AppTexts.vue?vue&type=style&index=0&id=2bf3779a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports